import { getCookie, setCookie } from 'global/js/Utils';
import ControllerBase from '../../../../global/js/ControllerBase';

// interface ShareDataProps {
// 	title?: string;
// 	text?: string;
// 	url?: string;
// 	file?: any;
// }

export default class ControllerButtonsGroup extends ControllerBase {

	private addToBasket;
	private assetSize;
	private apiUrl;
	private directDownload;
	private documentId;
	private share;
	private maxSize;

	constructor(element: HTMLElement) {
		super(element);
		this.init();
	}

	private setAdded(): void {
		this.$element.classList.add('added-to-list');
		const addedIcon = this.$element.querySelector('.js-other-icon')?.innerHTML || "";
		this.addToBasket.querySelector('.a-button__icon-wrapper').innerHTML = addedIcon;
		const buttonGroupsWithSameId = document.querySelectorAll(`.m-button-group[data-id="${this.documentId}"]`);
		if (buttonGroupsWithSameId.length > 1) {
			for (const group of buttonGroupsWithSameId) {
				group.classList.add('added-to-list');
				const iconWrapper = group.querySelector('[data-download="add-to-donwloadlist"] .a-button__icon-wrapper') as HTMLElement;
				if (iconWrapper) {
					iconWrapper.innerHTML = addedIcon;
				}
			}
		}
	}

	private init(): void {
		this.apiUrl = this.$element.getAttribute('data-api-url');
		this.maxSize = this.$element.getAttribute('data-max-size');
		this.assetSize = parseInt(this.$element.getAttribute('data-size') || '0');
		const assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]");
		this.documentId = this.$element.getAttribute('data-id');
		this.addToBasket = this.$element.querySelector('[data-download="add-to-donwloadlist"]');
		this.directDownload = this.$element.querySelector('[data-download="direct-download"]');
		this.share = this.$element.querySelector('[data-download="share"]');
		if (this.addToBasket) this.addToBasket.addEventListener("click", () => this.addToAssetDownloadList());
		if (this.directDownload) this.directDownload.addEventListener("click", () => this.directDownloadHandler());
		if (this.share) this.share.addEventListener("click", () => this.shareHandler());
		assetDownloadList.indexOf(`"${this.documentId}"`) > -1
			? this.setAdded()
			: this.$element.classList.remove('added-to-list');

		// Do not show add to DownloadList Button if Download Basket is not mantained in page
		const downloadList = document.querySelector('.o-download-list') as HTMLElement;
		if (downloadList) this.addToBasket?.classList.remove('d-none')
	}


	// Add to DownloadList
	private addToAssetDownloadList(): void {
		const id = JSON.stringify(this.documentId);
		const assetDownloadList = JSON.parse(getCookie('assetDownloadList') || "[]");
		let basketSize = parseInt(getCookie('basketSize') || "0");
		if (assetDownloadList.indexOf(id) < 0) {
			basketSize = basketSize + parseInt(this.assetSize);
			if (basketSize > parseInt(this.maxSize)) {
				const errorMessage = document.querySelector('[data-show-message]') as HTMLElement;
				if (errorMessage) errorMessage.setAttribute('data-show-message', 'true');
				else alert('Max size reached...');
				return;
			}
			assetDownloadList.push(id);
			setCookie('basketSize', 1, `${basketSize}`);
			setCookie('lastSize', 1, `${this.assetSize}`);
			setCookie('assetDownloadList', 1, JSON.stringify(assetDownloadList));
		}
		this.setAdded();
	}

	// Direct Download
	private async directDownloadHandler() {
		let href = this.apiUrl;
		let options = {};
		const id = this.documentId;
		this.$element.classList.add('downloaded-already');
		if (this.apiUrl) {
			options = {
				headers: {
					"Content-Type": "application/json"
				},
				method: 'POST',
				body: JSON.stringify({
					"action": "get-token",
					"documentIds": [id],
				})
			};
		} else {
			href = '/downloadAll.json';
		}
		await fetch(href, options)
			.then(response => response.json())
			.then((response) => {
				if (response.data?.['download-token']?.length) {
					const token = response.data['download-token'];
					const downloadUrl = `/download-assets-zipstream/${token}`;
					const a = document.createElement('a');
					a.setAttribute('download', '');
					a.setAttribute('href', downloadUrl);
					a.click();
				}
			})
			.catch(err => console.error(err));
	}

	// Share URL
	private shareHandler() {

		const windowNavigator = window.navigator;

		// SHARING OLD FASHION WAY == copy to clipboard
		// const windowUrl = window.location.href;
		// if (windowUrl !== undefined) {
		// 	alert('Successfully copied to clipboard!');
		// 	windowNavigator.clipboard.writeText(windowUrl);
		// }

		// SHARING DOCUMENT OBJECT WITH BROWSER SHARING API ===============
		const shareData = this.assetFetchHandler();
		if (shareData === undefined || shareData === null) { return; }
		else {

			if (windowNavigator && windowNavigator.share) {
				windowNavigator
					.share(shareData)
					.then(() => console.info('Successful share'))
					.catch((error) => console.error('Error sharing', error));
			} else {

				if (shareData?.url !== undefined) {
					alert('Successfully copied to clipboard!');
					windowNavigator.clipboard.writeText(shareData?.url);
				}

			}
		}
	}

	//Browser API share function with Options, for moment not used!
	private assetFetchHandler() {
		// const sendRequest = async () => {}
		const windowUrl = window.location.href || undefined;
		const title = document.head?.querySelector('title')?.textContent || `Share asset: ${this.documentId}!`;
		const text = document.head?.querySelector('meta[name="description"]')?.getAttribute('content') || `Download asset with assetId:${this.documentId}`;
		return {
			title,
			text,
			url: windowUrl,
			file: []
		}
	}

}


